import { queryOptions, type QueryClient } from '@tanstack/react-query'

import { marketEndpoints } from '@/api/endpointCache'
import { prefetchRouteData } from '@/app/query-client'
import { marketKeys } from '@/features/market/api/keys'
import { LIVE_MAX_LIMIT } from '@/features/market/api/marketApi'
import { registerCompanyLogos } from '@/lib/company-logos'

/**
 * Fills the logo directory `StockAvatar` reads from `/market/live/`'s
 * `logo_url`s. It goes through the shared endpoint entry, so on Home, Live
 * Market, Floorsheet, Depth or Watchlist it is the same request those screens
 * make; anywhere else it is one ~18 KB read per session. `staleTime: Infinity`
 * because a company's logo file does not change between sessions, while the
 * entry's prices go stale in a minute.
 */
const companyLogosQueryOptions = () =>
  queryOptions({
    queryKey: marketKeys.companyLogos(),
    queryFn: async ({ client }) => {
      const page = await marketEndpoints(client).live(LIVE_MAX_LIMIT)
      registerCompanyLogos(page.rows.map((row) => ({ symbol: row.key, logoUrl: row.logo_url })))
      return page.rows.length
    },
    staleTime: Infinity,
  })

/** Started as the signed-in app is entered and never awaited, like `prefetchMarketRail`. */
export const prefetchCompanyLogos = (client: QueryClient): void => {
  prefetchRouteData(client, companyLogosQueryOptions())
}
